export var UPDATE_ACCIDENT_QUESTIONS = "UPDATE_ACCIDENT_QUESTIONS";
export var updateAccidentQuestions = function (payload) { return ({
    type: UPDATE_ACCIDENT_QUESTIONS,
    payload: payload,
}); };
